export const useSendCardsAccess = () => {
  // Temporarily enabled for everyone
  return true;
};
